var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadSectionImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 370,
    viewBox: "0 0 508 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.508 326L401.008 356.576L442.993 337L349.77 309.787L311.508 326Z",
    fill: "url(#paint0_linear_734_21633)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.217 296.196C318.757 298.402 321.787 298.938 323.986 297.394C326.186 295.849 326.721 292.808 325.182 290.602L296.004 248.796L319.823 232.063L349.001 273.869C359.753 289.274 356.019 310.507 340.663 321.292C325.309 332.076 304.148 328.332 293.397 312.929L247.051 246.534C255.649 241.894 263.636 236.261 270.861 229.79L317.217 296.196Z",
    fill: "#FFC233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.589 13.4241C256.842 13.4241 312.171 68.9325 312.171 137.406C312.171 205.879 256.842 261.387 188.589 261.387C120.337 261.387 65.0078 205.879 65.0078 137.406C65.0078 68.9325 120.337 13.4241 188.589 13.4241ZM188.589 42.5962C136.396 42.5962 94.0835 85.0454 94.0835 137.408C94.084 189.77 136.396 232.217 188.589 232.217C240.783 232.217 283.092 189.77 283.093 137.408C283.093 85.0455 240.783 42.5964 188.589 42.5962Z",
    fill: "#F25C3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.937 169.48C160.592 194.776 195.344 200.923 220.558 183.211C233.567 174.073 241.49 160.395 243.698 145.771L272.447 150.14C269.097 172.328 257.029 193.204 237.237 207.108C198.868 234.06 145.984 224.706 119.118 186.213L142.937 169.48Z",
    fill: "#FFC233"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_21633",
    x1: 374.37,
    y1: 200.606,
    x2: 451.131,
    y2: 339.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313132",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSectionImage);
export default __webpack_public_path__ + "static/media/headSectionImage.45c6db951d3a4fe589349a845840f4cc.svg";
export { ForwardRef as ReactComponent };